import React from 'react'
import {Element} from 'react-scroll'
import './About.css'
import {Link} from 'react-scroll';

function About(){
    return(
        <Element className="about__container" id='about'>
         <div className='about__content'>
             <div className='about__info'>
             <img src='./Assets/Pic.jpg' className='about__img' alt='my picture'/>
             <p className='about__para'>Hi, I'm Jeeva , <br/> and I'm a Front-End <br/> <span>Web Developer</span>.</p>
             </div>
         </div>
         <div className='about__con-btn'>
            <Link className='about__btn' to="contact" smooth={true} duration={1000} >LET'S TALK </Link>
             </div>
        </Element>
        
    )
}
export default About;
